/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Enumaspect2Inputs */

const de__class_enumaspect2 = /** @type {(inputs: _Class_Enumaspect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist`)
};

/**

* @param {_Class_Enumaspect2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_enumaspect2 = /** @type {((inputs?: _Class_Enumaspect2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Enumaspect2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_enumaspect2(inputs)
});
export { _class_enumaspect2 as "_class_EnumAspect" }